(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-card-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-card-slider')) {
    class CollectionCardSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;

        this.update = this.update.bind(this);
        this.prev && this.prev.addEventListener('click', () => this.go(-1));
        this.next && this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
        });
        this.ro = new ResizeObserver(this.update);
        this.ro.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.ro && this.ro.disconnect();
      }

      step() {
        const item = this.track.querySelector('.ccs__item');
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / (item.offsetWidth + gap)));
        return perView * (item.offsetWidth + gap);
      }

      go(dir) {
        this.track.scrollBy({ left: dir * this.step() });
      }

      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth - 2;
        const atStart = t.scrollLeft <= 2;
        const atEnd = t.scrollLeft >= max;
        if (this.prev) this.prev.disabled = atStart;
        if (this.next) this.next.disabled = atEnd;
        this.classList.toggle('is-end', atEnd);
        const arrows = this.querySelector('.ccs__arrows');
        if (arrows) arrows.hidden = t.scrollWidth <= t.clientWidth + 2;
      }
    }
    customElements.define('collection-card-slider', CollectionCardSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
